<div>
    <div class="mb-4">
        <button type="button" class="chart-toggle storico-toggle" (click)="showStorico = !showStorico">
            <span class="flex items-center gap-2 font-semibold">
                <i class="pi pi-history"></i>
                Storico Rilevamenti Deviatoio {{ deviatoioId }}
                <span *ngIf="normativa" class="text-gray-500 font-normal">(Normativa: {{ normativa.sigla }})</span>
            </span>
            <i class="pi" [ngClass]="showStorico ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </button>
    </div>

    <div *ngIf="showStorico" class="storico-body">
    <!-- === CASO 1: Scambio semplice === -->
    <ng-container *ngIf="tipoDeviatoio === 1">
        <p-table [value]="getRows('semplice')" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr>
                    <th>Data</th>
                    <th *ngFor="let col of columnsSemplice">{{ col }}</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                <!-- Riga normativa -->
                <tr *ngIf="rowIndex === 0 && getNormativaForTab('tab1')" class="bg-gray-100 font-semibold">
                    <td>Normativa</td>
                    <td *ngFor="let col of columnsSemplice" class="text-center">
                        <div class="flex items-center justify-center gap-1">
                            <p-tag [value]="getNormativaForTab('tab1')[col.toLowerCase()] ?? '-'" severity="info" rounded></p-tag>
                        </div>
                    </td>
                </tr>

                <!-- Riga dati -->
                <tr>
                    <td>{{ row.data | date: 'dd/MM/yyyy HH:mm' }}</td>
                    <td *ngFor="let col of columnsSemplice" class="text-center">
                        <div class="flex items-center justify-center gap-1">
                            <p-tag [value]="row[col]" [severity]="getSeverity(col, row[col], 'tab1')" rounded></p-tag>

                            <i *ngIf="getTrendIcon(col, row[col], 'tab1') === '↑'" class="pi pi-arrow-up text-green-500 text-xs"></i>
                            <i *ngIf="getTrendIcon(col, row[col], 'tab1') === '↓'" class="pi pi-arrow-down text-red-500 text-xs"></i>
                            <i *ngIf="getTrendIcon(col, row[col], 'tab1') === '='" class="pi pi-equals text-gray-400 text-xs"></i>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>

    <!-- === CASO 2: Scambio doppio (ramo1, ramo2, cuore) === -->
    <ng-container *ngIf="tipoDeviatoio === 2">
        <p-tabs [(value)]="activeTab">
            <p-tablist>
                <p-tab value="tab1">Ramo 1</p-tab>
                <p-tab value="tab2">Ramo 2</p-tab>
                <p-tab value="tab3">Cuore</p-tab>
            </p-tablist>

            <p-tabpanels>
                <!-- RAMO 1 -->
                <p-tabpanel value="tab1">
                    <p-table [value]="getRows('ramo1')" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Data</th>
                                <th *ngFor="let col of columnsRamo1">{{ col }}</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <tr *ngIf="rowIndex === 0" class="bg-gray-100 font-semibold">
                                <td>Normativa</td>
                                <td *ngFor="let col of columnsRamo1">
                                    <div class="flex items-center justify-center gap-1">
                                        <p-tag [value]="getNormativaForTab('tab1')[col.toLowerCase()] ?? '-'" severity="info"></p-tag>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>{{ row.data | date: 'dd/MM/yyyy HH:mm' }}</td>
                                <td *ngFor="let col of columnsRamo1" class="text-center">
                                    <div class="flex items-center justify-center gap-1">
                                        <p-tag [value]="row[col]" [severity]="getSeverity(col, row[col], 'tab1')" rounded></p-tag>

                                        <i *ngIf="getTrendIcon(col, row[col], 'tab1') === '↑'" class="pi pi-arrow-up text-green-500 text-xs"></i>
                                        <i *ngIf="getTrendIcon(col, row[col], 'tab1') === '↓'" class="pi pi-arrow-down text-red-500 text-xs"></i>
                                        <i *ngIf="getTrendIcon(col, row[col], 'tab1') === '='" class="pi pi-equals text-gray-400 text-xs"></i>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabpanel>

                <!-- RAMO 2 -->
                <p-tabpanel value="tab2">
                    <p-table [value]="getRows('ramo2')" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Data</th>
                                <th *ngFor="let col of columnsRamo2">{{ col }}</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <tr *ngIf="rowIndex === 0" class="bg-gray-100 font-semibold">
                                <td>Normativa</td>
                                <td *ngFor="let col of columnsRamo2" class="text-center justify-center">
                                    <div class="flex items-center justify-center gap-1">
                                        <p-tag [value]="getNormativaForTab('tab2')[col.toLowerCase()] ?? '-'" severity="info"></p-tag>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>{{ row.data | date: 'dd/MM/yyyy HH:mm' }}</td>
                                <td *ngFor="let col of columnsRamo2" class="text-center justify-center">
                                    <div class="flex items-center justify-center gap-1">
                                        <p-tag [value]="row[col]" [severity]="getSeverity(col, row[col], 'tab2')" rounded></p-tag>

                                        <i *ngIf="getTrendIcon(col, row[col], 'tab2') === '↑'" class="pi pi-arrow-up text-green-500 text-xs"></i>
                                        <i *ngIf="getTrendIcon(col, row[col], 'tab2') === '↓'" class="pi pi-arrow-down text-red-500 text-xs"></i>
                                        <i *ngIf="getTrendIcon(col, row[col], 'tab2') === '='" class="pi pi-equals text-gray-400 text-xs"></i>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabpanel>

                <!-- CUORE -->
                <p-tabpanel value="tab3">
                    <p-table [value]="getRows('cuoreInterno')" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Data</th>
                                <th *ngFor="let col of columnsCuore">{{ col }}</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <tr *ngIf="rowIndex === 0" class="bg-gray-100 font-semibold">
                                <td>Normativa</td>
                                <td *ngFor="let col of columnsCuore" class="text-center justify-center">
                                    <div class="flex items-center justify-center gap-1">
                                        <p-tag [value]="getNormativaForTab('tab3')[col.toLowerCase()] ?? '-'" severity="info"></p-tag>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>{{ row.data | date: 'dd/MM/yyyy HH:mm' }}</td>
                                <td *ngFor="let col of columnsCuore" class="text-center">
                                    <div class="flex items-center justify-center gap-1">
                                        <p-tag [value]="row[col]" [severity]="getSeverity(col, row[col], 'tab3')" rounded></p-tag>

                                        <i *ngIf="getTrendIcon(col, row[col], 'tab3') === '↑'" class="pi pi-arrow-up text-green-500 text-xs"></i>
                                        <i *ngIf="getTrendIcon(col, row[col], 'tab3') === '↓'" class="pi pi-arrow-down text-red-500 text-xs"></i>
                                        <i *ngIf="getTrendIcon(col, row[col], 'tab3') === '='" class="pi pi-equals text-gray-400 text-xs"></i>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </ng-container>

    <!-- === CASO 3: Scambio a TELAI (intersezione) === -->
    <ng-container *ngIf="tipoDeviatoio === 3">
        <p-tabs [(value)]="activeTabTelaio">
            <p-tablist>
                <p-tab *ngFor="let telaio of telai; let i = index" [value]="'tab' + (i + 1)">
                    <span>{{ telaio.label }}</span>
                </p-tab>
            </p-tablist>

            <p-tabpanels>
                <p-tabpanel *ngFor="let telaio of telai; let i = index" [value]="'tab' + (i + 1)">
                    <p-table [value]="getRows(telaio.value)" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Data</th>
                                <th *ngFor="let col of columnsTelaio[telaio.value]">{{ col }}</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <!-- Riga normativa -->
                            <tr *ngIf="rowIndex === 0" class="bg-gray-100 font-semibold">
                                <td>Normativa</td>
                                <td *ngFor="let col of columnsTelaio[telaio.value]" class="text-center justify-center">
                                    <p-tag [value]="getNormativaForTab('tab' + (i + 1))[col.toLowerCase()] ?? '-'" severity="info" rounded styleClass="w-full justify-center"></p-tag>
                                </td>
                            </tr>

                            <!-- Riga dati -->
                            <tr>
                                <td>{{ row.data | date: 'dd/MM/yyyy HH:mm' }}</td>
                                <td *ngFor="let col of columnsTelaio[telaio.value]" class="text-center">
                                    <div class="flex items-center justify-center gap-1">
                                        <p-tag [value]="row[col]" [severity]="getSeverity(col, row[col], 'tab' + (i + 1))" rounded styleClass="justify-center"></p-tag>

                                        <i *ngIf="getTrendIcon(col, row[col], 'tab' + (i + 1)) === '↑'" class="pi pi-arrow-up text-green-500 text-xs"></i>
                                        <i *ngIf="getTrendIcon(col, row[col], 'tab' + (i + 1)) === '↓'" class="pi pi-arrow-down text-red-500 text-xs"></i>
                                        <i *ngIf="getTrendIcon(col, row[col], 'tab' + (i + 1)) === '='" class="pi pi-equals text-gray-400 text-xs"></i>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </ng-container>
    </div>

    <!-- === Andamento nel tempo (grafico) — collassato di default, non invasivo === -->
    <div class="chart-section" *ngIf="rilevamenti.length">
        <button type="button" class="chart-toggle" (click)="showChart = !showChart">
            <span class="flex items-center gap-2 font-semibold">
                <i class="pi pi-chart-line"></i> Andamento nel tempo
            </span>
            <i class="pi" [ngClass]="showChart ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </button>

        <div *ngIf="showChart" class="chart-body">
            <div class="chart-controls">
                <div *ngIf="chartGroups.length > 1" class="chart-ctrl">
                    <label>Gruppo</label>
                    <p-select [options]="chartGroupOptions" optionLabel="label" optionValue="value" [(ngModel)]="selectedGroupPrefix" (onChange)="onChartGroupChange()"></p-select>
                </div>
                <div class="chart-ctrl">
                    <label>Misura</label>
                    <p-select [options]="chartColumnOptions" optionLabel="label" optionValue="value" [(ngModel)]="selectedColumn" (onChange)="buildChart()"></p-select>
                </div>

                <div class="chart-ctrl chart-ctrl-inline chart-ctrl-spacer">
                    <p-checkbox [(ngModel)]="fitTolerance" [binary]="true" inputId="fitTol" (onChange)="onFitToleranceChange()"></p-checkbox>
                    <label for="fitTol" style="text-transform:none; cursor:pointer">Adatta alla tolleranza</label>
                </div>
                <div class="chart-ctrl chart-ctrl-inline">
                    <button pButton type="button" icon="pi pi-search-minus" label="Reset zoom" severity="secondary" [outlined]="true" size="small" (click)="resetZoom()"></button>
                </div>
            </div>

            <div class="chart-wrap" *ngIf="chartData">
                <p-chart type="line" [data]="chartData" [options]="chartOptions"></p-chart>
            </div>
            <div *ngIf="!chartData" class="text-gray-500 text-sm p-4">Nessun dato graficabile per la misura selezionata.</div>

            <div class="chart-legend-hint" *ngIf="chartData">
                <span><span class="dot" style="background:#22c55e"></span>Valore entro tolleranza</span>
                <span><span class="dot" style="background:#ef4444"></span>Valore fuori tolleranza</span>
                <span><span class="dot" style="background:rgba(34,197,94,0.35)"></span>Banda/soglia normativa</span>
                <span><i class="pi pi-info-circle"></i> Scorri per zoomare, trascina per selezionare un'area, Ctrl+trascina per spostarti</span>
            </div>
        </div>
    </div>
</div>
